import { useFirestoreNoCompagny } from '../../firebase/useFirestore'

const OutputMeta = ({id}) => {

    const outputs = useFirestoreNoCompagny('Outputs', 'ID', id ? id : '')

  return (
    <>
        {outputs && outputs.map(item => (
            <span key={item.ID}>{item.Title}</span>
        ))}
    </>
  )
}

export default OutputMeta